<template>
    <el-steps :space="100" class="steps">
        <el-step class="cus-step" v-for="(step, index) in steps" align-center :key="index" :icon="'step-dot ' + step.status">
            <div
                :title="step.modifier != null && step.modifier != undefined ? `转运人：${step.modifier}` : ''"
                slot="title"
                class="align-center ellipsis"
                style="line-height: 22px; font-size: 14px; min-width: 80px"
            >
                <span
                    style="position: absolute; top: 0px; left: 0px; background: white; font-size: 10px"
                    v-if="index == 0 || $moment(steps[index - 1].occur_time).format('MM/DD') !== $moment(step.occur_time).format('MM/DD')"
                >
                    {{ step.occur_time && $moment(step.occur_time).format('MM/DD') }}
                </span>
                {{ step.occur_time && $moment(step.occur_time).format('HH:mm') }}<br />

                <span class="info" :title="step.modifier != null && step.modifier != undefined ? `转运人：${step.modifier}` : ''">{{ step.title || '&nbsp;' }}</span>
            </div>
            <div slot="description" class="align-center">
                <!-- <text-formatter type="datetime" v-model="step.occur_time"></text-formatter>   -->
                <!-- <div>{{$moment(step.occur_time).format('MM/DD HH:mm')}}</div> -->
                <slot :step="step" :index="index"></slot>
            </div>
        </el-step>
    </el-steps>
</template>

<script>
export default {
    name: `CusStep`,
    props: {
        steps: Array
    },
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {

    }
}
</script>

<style   lang="less">
.step-dot {
    content: ' ';
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: block;
    &.info {
        background: #909399;
    }
    &.danger {
        background: #f56c6c;
    }
    &.primary {
        background: var(--primary-color, #009688);
    }
    &.warning {
        background: #e6a23c;
    }
}
.steps {
    overflow: scroll;
}
.cus-step {
    .danger {
        color: #f56c6c;
    }
    .primary {
        color: var(--primary-color, #009688);
    }
    .info {
        color: #909399;
    }
    .warning {
        color: #e6a23c;
    }
}
.cus-step {
    &:first-of-type {
        .el-step__head .el-step__line {
            width: 50%;
            margin-left: 50%;
        }
    }
    &:last-of-type {
        .el-step__head .el-step__line {
            width: 50%;
            display: block;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common/CusStep.vue